// Function to convert hex to RGB
export function hexToRgb(hex) {
  // Remove the leading '#' if present
  hex = hex.replace("#", "");

  // Convert 3-digit hex to 6-digit hex if necessary
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  // Convert to RGB values
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return { r, g, b };
}

// Function to calculate YIQ contrast and return white or black
export default function getContrastTextColor(hex) {
  const { r, g, b } = hexToRgb(hex);

  // YIQ formula
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  // Return black for light background, white for dark background
  return yiq >= 128 ? "#000000" : "#FFFFFF";
}
